/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalCoverageDetail
 */
export interface AdditionalCoverageDetail {
    /**
     * 
     * @type {string}
     * @memberof AdditionalCoverageDetail
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalCoverageDetail
     */
    value?: string;
}

/**
 * Check if a given object implements the AdditionalCoverageDetail interface.
 */
export function instanceOfAdditionalCoverageDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdditionalCoverageDetailFromJSON(json: any): AdditionalCoverageDetail {
    return AdditionalCoverageDetailFromJSONTyped(json, false);
}

export function AdditionalCoverageDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalCoverageDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function AdditionalCoverageDetailToJSON(value?: AdditionalCoverageDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

